import { API_BASE } from "../auth/authApi";

import type { VisitStats, VisitSnapshot } from "../stats/visitStats";

export type GameStats = VisitStats;
export type GamePopularitySnapshot = VisitSnapshot;

export type GamePopularity = Record<string, GamePopularitySnapshot>;

export async function recordGameVisit(
  name: string,
  sessionId: string
): Promise<void> {
  const response = await fetch(
    `${API_BASE}/api/games/${encodeURIComponent(name)}/visit`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ sessionId })
    }
  );
  if (!response.ok)
    throw new Error(`Failed to record game visit (${response.status})`);
}

export async function fetchGamePopularity(
  signal?: AbortSignal
): Promise<GamePopularity> {
  const response = await fetch(`${API_BASE}/api/games/popularity`, {
    signal,
    headers: { Accept: "application/json" }
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch game popularity (${response.status})`);
  }

  return response.json();
}
